// KIMU 2.0 — theme JS
// -----------------------------------------

(function () {
  'use strict';

  // ===== Header scroll state =====
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ===== Announcement bar rotator =====
  const announcement = document.querySelector('.announcement__track');
  if (announcement) {
    const items = announcement.querySelectorAll('.announcement__item');
    if (items.length > 1) {
      let idx = 0;
      items[0].classList.add('is-active');
      setInterval(() => {
        items[idx].classList.remove('is-active');
        idx = (idx + 1) % items.length;
        items[idx].classList.add('is-active');
      }, 4000);
    } else if (items.length === 1) {
      items[0].classList.add('is-active');
    }
  }

  // ===== Drawer system =====
  const openDrawer = (id) => {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const focusable = drawer.querySelector('button, a, input');
    if (focusable) focusable.focus();
  };
  const closeDrawer = (drawer) => {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  };
  document.querySelectorAll('[data-drawer-open]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer(btn.dataset.drawerOpen);
    });
  });
  document.querySelectorAll('.drawer').forEach((drawer) => {
    drawer.querySelectorAll('[data-drawer-close], .drawer__overlay').forEach((el) => {
      el.addEventListener('click', () => closeDrawer(drawer));
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
    }
  });

  // ===== Mobile nav accordion =====
  document.querySelectorAll('.mobile-nav__trigger').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.mobile-nav__item');
      item.classList.toggle('is-open');
    });
  });

  // ===== Predictive search =====
  const searchForm = document.querySelector('.search-drawer__form');
  if (searchForm) {
    const input = searchForm.querySelector('input[type="search"]');
    const results = document.querySelector('.search-drawer__results');
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(() => {
        fetch(`${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`)
          .then((r) => r.json())
          .then((data) => {
            const items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) {
              results.innerHTML = `<p style="text-align:center;color:#888">Sin resultados para "${q}"</p>`;
              return;
            }
            results.innerHTML = items.map((p) => `
              <a href="${p.url}" style="display:grid;grid-template-columns:60px 1fr auto;gap:1rem;padding:0.75rem 0;border-bottom:1px solid var(--color-border);align-items:center">
                <img src="${p.featured_image && p.featured_image.url}" alt="" style="width:60px;height:60px;object-fit:cover;border-radius:4px;background:var(--color-pink-soft)" loading="lazy">
                <div>
                  <strong style="font-family:var(--font-display);font-size:1.1rem">${p.title}</strong>
                  <div style="font-size:0.8rem;color:#888">${p.vendor || ''}</div>
                </div>
                <span style="font-weight:500">${p.price}</span>
              </a>
            `).join('');
          })
          .catch(() => {});
      }, 200);
    });
  }

  // ===== Refresh cart count after add =====
  window.kimuRefreshCart = function () {
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      });
  };

  // ===== Quick add buttons (from product cards) =====
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.quickAdd;
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = 'Agregando...';
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then((r) => r.json())
      .then(() => {
        btn.textContent = '✓ Agregado';
        window.kimuRefreshCart();
        openDrawer('cart-drawer');
        setTimeout(() => { btn.textContent = 'Agregar'; btn.disabled = false; }, 1500);
      })
      .catch(() => {
        btn.textContent = 'Error';
        btn.disabled = false;
      });
  });
})();
